var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_995_14751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4286 20.125V21.9219C16.4286 22.5173 15.8769 23 15.1964 23H1.23214C0.551641 23 0 22.5173 0 21.9219V5.39062C0 4.79519 0.551641 4.3125 1.23214 4.3125H4.92857V17.6094C4.92857 18.9965 6.21827 20.125 7.80357 20.125H16.4286ZM16.4286 4.67188V0H7.80357C7.12307 0 6.57143 0.482686 6.57143 1.07812V17.6094C6.57143 18.2048 7.12307 18.6875 7.80357 18.6875H21.7679C22.4484 18.6875 23 18.2048 23 17.6094V5.75H17.6607C16.983 5.75 16.4286 5.26484 16.4286 4.67188ZM22.6391 3.27799L19.2537 0.315756C19.0227 0.113582 18.7093 1.49498e-06 18.3825 0L18.0714 0V4.3125H23V4.04032C23 3.75439 22.8702 3.48018 22.6391 3.27799Z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_995_14751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconGray);
export default __webpack_public_path__ + "static/media/copy-icon-gray.90b1f1c62331fa236cf407852849061f.svg";
export { ForwardRef as ReactComponent };